<template>
  <div class="selected-payment-header">
    <div class="header-content">
      <div class="method-info">
        <div class="method-icon">
          <img :src="methodIcon" :alt="methodLabel" />
        </div>
        <div class="method-details">
          <span class="method-label">Payment Method</span>
          <span class="method-name">{{ methodLabel }}</span>
        </div>
      </div>
      <button
        type="button"
        class="change-button"
        :disabled="disabled"
        @click="$emit('change')"
      >
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path>
          <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path>
        </svg>
        Change
      </button>
    </div>
  </div>
</template>

<script>
import { PAYMENT_METHODS, PAYMENT_METHOD_CONFIG } from '@/constants/paymentMethods'

export default {
  name: 'SelectedPaymentHeader',
  props: {
    selectedMethod: {
      type: String,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    methodConfig() {
      return PAYMENT_METHOD_CONFIG[this.selectedMethod] || {}
    },
    methodLabel() {
      return this.methodConfig.label || this.selectedMethod
    },
    methodIcon() {
      const icon = this.methodConfig.icon || 'Kazang.png'
      return require(`@/assets/${icon}`)
    }
  }
}
</script>

<style scoped>
.selected-payment-header {
  background: #f0f9ff;
  border: 1px solid #bae6fd;
  border-radius: 0.75rem;
  padding: 1rem 1.25rem;
  margin-bottom: 1rem;
}

.header-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
}

.method-info {
  display: flex;
  align-items: center;
  gap: 0.875rem;
}

.method-icon {
  width: 40px;
  height: 40px;
  background: #ffffff;
  border: 1px solid #e0f2fe;
  border-radius: 0.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
}

.method-icon img {
  width: 24px;
  height: 24px;
  object-fit: contain;
}

.method-details {
  display: flex;
  flex-direction: column;
  gap: 0.125rem;
}

.method-label {
  font-size: 0.75rem;
  color: #0369a1;
  text-transform: uppercase;
  letter-spacing: 0.025em;
}

.method-name {
  font-size: 0.9375rem;
  font-weight: 600;
  color: #0c4a6e;
}

.change-button {
  display: inline-flex;
  align-items: center;
  gap: 0.375rem;
  background: #ffffff;
  border: 1px solid #0ea5e9;
  color: #0ea5e9;
  font-size: 0.8125rem;
  font-weight: 500;
  padding: 0.5rem 0.875rem;
  border-radius: 0.375rem;
  cursor: pointer;
  transition: all 0.2s;
}

.change-button:hover:not(:disabled) {
  background: #0ea5e9;
  color: #ffffff;
}

.change-button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.change-button svg {
  width: 14px;
  height: 14px;
}

@media (max-width: 576px) {
  .header-content {
    flex-direction: column;
    align-items: stretch;
    gap: 0.75rem;
  }

  .change-button {
    justify-content: center;
  }
}
</style>
